import { __rest } from '../../_virtual/_tslib.js';
import { IconLinkGroupWrapper } from '@lsg/shared';
import { createElement } from 'react';

/** @deprecated ( 10.11.2021) */
var Directions;
(function (Directions) {
  Directions["VERTICAL"] = "vertical";
  Directions["HORIZONTAL"] = "horizontal";
  Directions["TABLE"] = "table";
  Directions["FLIP_XS"] = "flip-xs";
  Directions["FLIP_SM"] = "flip-sm";
  Directions["FLIP_MD"] = "flip-md";
  Directions["COLLAPSE_XS"] = "collapse-xs";
  Directions["COLLAPSE_SM"] = "collapse-sm";
  Directions["COLLAPSE_MD"] = "collapse-md";
})(Directions || (Directions = {}));
var IconLinkGroup = function IconLinkGroup(_a) {
  var _a$direction = _a.direction,
    direction = _a$direction === void 0 ? "vertical" : _a$direction,
    props = __rest(_a, ["direction"]);
  return /*#__PURE__*/createElement(IconLinkGroupWrapper, Object.assign({}, props, {
    direction: direction
  }));
};
IconLinkGroup.Directions = Directions;
IconLinkGroup.displayName = "IconLinkGroup";

export { Directions, IconLinkGroup };
